<div id="sticky-header" class="techno_nav_manu transparent_menu white d-md-none d-lg-block d-sm-none d-none style-two">
    <div class="container">
        <div class="row">
            <img class="down" src="../../../assets/images/logos/wm-white.png" alt="" class="logo-img"><span class="logo-text">Web <br /> Monkeyz</span>
            <div class="menu">
                <ul class="clearfix">
                    <li><a href="#home">Home</a></li>
                    <li><a href="#about">About Us</a></li>
                    <li><a href="#services">Our Services</a></li>
                    <li><a href="#contact">Contact Us</a></li>
                    <div class="donate-btn-header">
                        <a class="dtbtn" href="#contact">Get A Quote</a>	
                    </div>
                </ul>
            </div>
        </div>
    </div>
</div>
    
<!----- Mobile Menu Area ----->
<div class="mobile-menu-area d-sm-block d-md-block d-lg-none">
    <div class="mobile-menu">
        <img class="down" src="../../../assets/images/logos/wm-white.png" alt="" class="logo-img-mobile">
        <nav class="techno_menu">
            <ul class="clearfix">
                <li><a href="#home">Home</a></li>
                <li><a href="#about">About Us</a></li>
                <li><a href="#services">Our Services</a></li>
                <li><a href="#contact">Contact Us</a></li>
            </ul>
        </nav>
    </div>
</div>
<!-- <div class="mobile-menu-area d-sm-block d-md-block d-lg-none">
    <div class="mobile-menu">
        <img class="down" src="../../../assets/images/logos/wm-white.png" alt="" class="logo-img-mobile">
        <nav class="techno_menu">
            <ul class="clearfix">
                <li><a href="#home">Home</a></li>
                <li><a href="#about">About Us</a></li>
                <li><a href="#services">Our Services</a></li>
                <li><a href="#contact">Contact Us</a></li>
            </ul>
        </nav>
    </div>
    
</div> -->

    <!-- <div class="container">
        <div class="row">
            <img class="down" src="../../../assets/images/logos/wm-white.png" alt="" class="logo-img-mobile">
            <div class="menuMob">
                <ul class="clearfix">
                    <li><a href="#home">Home</a></li>
                    <li><a href="#about">About Us</a></li>
                    <li><a href="#services">Our Services</a></li>
                    <li><a href="#contact">Contact Us</a></li>
                </ul>
            </div>
        </div>
    </div> -->